export default {
    path:'/home',
    mapPath:'/home',
    component: require('./index').default,
    parent:'root',
};